import { render, staticRenderFns } from "./SettingModal.vue?vue&type=template&id=4950c7f3&scoped=true&"
import script from "./SettingModal.vue?vue&type=script&lang=js&"
export * from "./SettingModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingModal.vue?vue&type=style&index=0&id=4950c7f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4950c7f3",
  null
  
)

export default component.exports